var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 6.5C10.5 8.9853 8.4853 11 6 11C3.51472 11 1.5 8.9853 1.5 6.5C1.5 4.01472 3.51472 2 6 2C8.4853 2 10.5 4.01472 10.5 6.5ZM9.6793 11.2399C8.6632 12.0297 7.3865 12.5 6 12.5C2.68629 12.5 0 9.8137 0 6.5C0 3.18629 2.68629 0.5 6 0.5C9.3137 0.5 12 3.18629 12 6.5C12 7.8865 11.5297 9.1632 10.7399 10.1792L15.5304 14.9697L14.4697 16.0303L9.6793 11.2399Z",
    fill: "#080341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconNew);
export default __webpack_public_path__ + "static/media/search_icon_new.307c278233c38609bd25b675d3e651f9.svg";
export { ForwardRef as ReactComponent };